import axios from 'axios'
export async function request(url, headers, httpVerb, requestData = {}) {
  try {
    const fetchOptions = {
      url,
      data: requestData,
      headers: {
        Authorization: `Bearer ${headers.accessToken}`,
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key':process.env.REACT_APP_APIM_KEY
      },
    }
    const response = await axios(fetchOptions)
    return response.data
  } catch (err) {
    return Promise.reject(err.message)
  }
}
